module.exports = __webpack_public_path__ + "img/227.b708cc3c.png";